<template>
    <UICard
        :title="config.data.title"
        :badge="config.data.badge"
        class="mx-4"
    >
        <div class="flex">
            <div class="flex-col items-center w-6/12 justify-center text-center">
                <div class="min-w-15 min-h-15 mb-3 px-2 text-[1.875rem] inline-flex font-semibold items-center justify-center ring-1 ring-inset rounded-xl bg-gray-50 text-gray-700 ring-gray-500/20">
                    {{ config.data.left_score }}
                </div>
                <div class="text-sm font-medium text-gray-800">
                    {{ config.data.left_text }}
                </div>
            </div>
            <div class="max-h-15 inline-flex items-center font-semibold text-2xl text-gray-400 dark:text-gray-600">
                -
            </div>
            <div class="flex-col items-center w-6/12 justify-center text-center">
                <div class="min-w-15 min-h-15 mb-3 px-2 text-[1.875rem] inline-flex font-semibold items-center justify-center ring-1 ring-inset rounded-xl bg-gray-50 text-gray-700 ring-gray-500/20">
                    {{ config.data.right_score }}
                </div>
                <div class="text-sm font-medium text-gray-800">
                    {{ config.data.right_text }}
                </div>
            </div>
        </div>
    </UICard>
</template>

<script setup>
    const props = defineProps({
        config: Object,
    })
</script>
